import { put, select, takeLatest } from 'redux-saga/effects'
import { PatientMedicalHistoryConstants } from '../store/patientMedicalHistory.constants'
import { getPatientMedicalHistorySelector } from '../selectors'
import { IPatientMedicalHistoryState } from '../store/patientMedicalHistory.types'
import { getPcrIdSelector } from '../../home/selectors'
import {
  setEmergencyInfoForm,
  setObtainedFrom,
  setSelectedMedicalHistory,
  setSelectedMedicalHistoryIcdNemsisBasic,
} from '../store/patientMedicalHistory.actions'
import { PatientMedicalHistoryLayoutOptionsConstants } from '../store/patientMedicalHistoryLayoutOptions.constants'
import { getConfigurationsSelector } from '../../configurations/selectors'
import { IConfigurationsState } from '../../configurations/store/configurations.types'

export function* handleNoKnownHistory() {
  const patientMedicalHistory: IPatientMedicalHistoryState = yield select(getPatientMedicalHistorySelector)
  const configuration: IConfigurationsState = yield select(getConfigurationsSelector)
  const { serviceConfig } = configuration
  const { noKnownHistory } = patientMedicalHistory
  if (noKnownHistory) {
    const pcrID: string = yield select(getPcrIdSelector)
    if (pcrID) {
      if (serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC) {
        yield put(setSelectedMedicalHistoryIcdNemsisBasic([]))
      }
      yield put(setSelectedMedicalHistory([]))
      yield put(setObtainedFrom([]))
      yield put(setEmergencyInfoForm(null))
    } else {
      // todo: add to audit log
    }
  }
}
export function* handleNoKnownHistorySaga() {
  yield takeLatest([PatientMedicalHistoryConstants.SET_NO_KNOWN_HISTORY], handleNoKnownHistory)
}
